'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function BFFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-cv0iff8ea", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-kois0xvqz", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-gwcjfabq4" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-gwcjfabq4", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-cv0iff8ea)" }, /* @__PURE__ */ React.createElement("use", { fill: "#5eaa22", xlinkHref: "#mantine-gwcjfabq4" }), /* @__PURE__ */ React.createElement("path", { fill: "#c51918", d: "M0 0h32v12H0z", mask: "url(#mantine-kois0xvqz)" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#feca00",
        d: "M16.035 15.77l-4.703 3.56 1.505-5.797-4.41-3.53h5.257l2.35-5.145 2.352 5.146h5.257l-4.457 3.534 1.551 5.792z",
        mask: "url(#mantine-kois0xvqz)"
      }
    )))
  );
}

export { BFFlag };
//# sourceMappingURL=BF.mjs.map
